//import Libraries
import React from 'react';

//import Components


//import Styles

const adminNav = (props) => {
    const style = {
        backgroundColor: "var(--main-bg-op-07)",
        height: "120px"
    }
    return (
        <div className="AdminNav" style={style}>
            <div style={{width:"1200px", margin:"auto", padding: "40px 0px", display: "flex"}}>
                <img style={{height: "40px", padding: "0px 20px 0px 0px"}} src={require('../../../assets/logo/logo-main-ko.svg')} className="Logo" alt=""/>
                <h3 style={{color: "var(--admin-color)", transform: "translateY(5px)", fontWeight: "700"}}>관리자 페이지</h3>
            </div>

        </div>
        );
}


export default adminNav;


// WEBPACK FOOTER //
// ./src/pages/Admin/AdminNav/AdminNav.js